import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, DropDownMenu, MenuItem } from 'material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


import Btn from '../../../components/Btn';
import '../../../grid.css';

class OBS extends Component {
    static propTypes = {
        obsDownPayment: PropTypes.number.isRequired,
        setOBSDownPayment: PropTypes.func.isRequired,
        isVisible: PropTypes.bool.isRequired,
        isLocked: PropTypes.bool.isRequired,
        setOBSIsVisible: PropTypes.func.isRequired,
        setOBSCredit: PropTypes.func.isRequired,
        obsCredit: PropTypes.number.isRequired,
        cashprice: PropTypes.number.isRequired,
        showOBS: PropTypes.bool.isRequired,
        resiToggle: PropTypes.bool.isRequired,
        setShowOBS: PropTypes.func.isRequired,
        obsTerm: PropTypes.number.isRequired,
        setOBSTerm: PropTypes.func.isRequired,
        setSelectedFinancing: PropTypes.func.isRequired,
    };

    toggleOBS() {
        const { setOBSIsVisible, isVisible } = this.props;
        setOBSIsVisible(!isVisible);
    }

    toggleShowOBS() {
        const { setShowOBS, showOBS, setSelectedFinancing } = this.props;
        setShowOBS(!showOBS);
        if (showOBS) {
            setSelectedFinancing(4);
        }
        if (!showOBS) {
            setSelectedFinancing(3);
        }
    }

    handleOBSCredit(value) {
        const { setOBSCredit } = this.props;
        setOBSCredit(value);
    }

    handleOBSTermChange(value) {
        const { setOBSTerm } = this.props;
        setOBSTerm(Number(value));
    }

    handleOBSDownPaymentChange(value) {
        const { setOBSDownPayment } = this.props;
        setOBSDownPayment(Number(value));
    }

    render() {
        const {
            isVisible,
            isLocked,
            showOBS,
            obsDownPayment,
            obsTerm,
            obsCredit,
            resiToggle,
            cashprice,
        } = this.props;

        let isDisabled = isLocked;
        if (resiToggle === true || isLocked === true) {
            isDisabled = true;
        }
        if (cashprice < 499999) {
            isDisabled = true;
        }


        return (
            <div>
                <Btn
                    label="Operating Lease"
                    onClick={(e, value) => this.toggleOBS(value)}
                />
                { isVisible ? (
                    <div>
                        {cashprice > 499999 ? (
                            <div>
                                <div className="col span-1-of-8 checkboxes">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isDisabled}
                                                onChange={(e, value) => this.toggleShowOBS(value)}
                                                checked={showOBS}
                                            />
                                        }
                                        label="Include OBS"
                                    />
                                </div>
                                {showOBS ?
                                    <div>
                                        <div className="col span-1-of-4">
                                            <DropDownMenu
                                                fullWidth
                                                label="OBS Credit"
                                                value={obsCredit}
                                                onChange={(e, index, value) =>
                                                    this.handleOBSCredit(value)}
                                                disabled={isDisabled}
                                            >
                                                <MenuItem value={1} disabled primaryText="Investment Grade Credit" />
                                            </DropDownMenu>
                                        </div>
                                        <div className="col span-3-of-8">
                                            <TextField
                                                defaultValue={obsDownPayment}
                                                onChange={(e, value) =>
                                                    this.handleOBSDownPaymentChange(value)}
                                                floatingLabelText="OBS Down Payment"
                                                disabled={isDisabled}
                                            />
                                        </div>
                                        <div className="col span-1-of-4">
                                            <DropDownMenu
                                                fullWidth
                                                label="OBS Term"
                                                value={obsTerm}
                                                onChange={(e, index, value) =>
                                                    this.handleOBSTermChange(value)}
                                                disabled={isDisabled}
                                            >
                                                <MenuItem value={60} disabled primaryText="60 Month" />
                                                <MenuItem value={84} primaryText="84 Month" />
                                                <MenuItem value={120} disabled primaryText="120 Month" />
                                            </DropDownMenu>
                                        </div>
                                    </div> : null}
                            </div>
                        ) : <p>System Price must be $500,000 or greater to be eligible for OBS.</p>}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default OBS;



// WEBPACK FOOTER //
// ./src/containers/Inputs/OBS/OBS.js